/* Manchester · Track B — Size Chart modal (replaces v6 cc-modal which lost
   its styles when we dropped v6's styles.css.liquid). Renders the size
   guide as a proper centered overlay with backdrop, focus trap, and
   keyboard accessibility (Escape to close).

   Trigger: any anchor with .size-chart-link class.
   Content source: element pointed to by data-cc-modal-contentelement
   (we keep the v6 attribute so the Liquid snippet doesn't need changes).
*/
(function () {
  'use strict';

  var openModal = null;
  var lastFocused = null;

  function buildModal(contentHTML) {
    var wrap = document.createElement('div');
    wrap.className = 'mfg-size-modal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Guía de tallas');
    wrap.innerHTML =
      '<div class="mfg-size-modal__backdrop" data-close></div>' +
      '<div class="mfg-size-modal__panel" role="document">' +
        '<button type="button" class="mfg-size-modal__close" aria-label="Cerrar" data-close>×</button>' +
        '<div class="mfg-size-modal__body"></div>' +
      '</div>';
    wrap.querySelector('.mfg-size-modal__body').innerHTML = contentHTML;
    return wrap;
  }

  function close() {
    if (!openModal) return;
    openModal.classList.add('is-closing');
    setTimeout(function () {
      if (openModal && openModal.parentNode) openModal.parentNode.removeChild(openModal);
      openModal = null;
      document.body.classList.remove('mfg-size-modal-open');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }, 180);
  }

  function open(contentSel) {
    var src = document.querySelector(contentSel);
    if (!src) return;
    close();
    lastFocused = document.activeElement;
    // Use the .size-chart-content innerHTML (already has tabs + images)
    var html = src.innerHTML;
    var modal = buildModal(html);
    document.body.appendChild(modal);
    document.body.classList.add('mfg-size-modal-open');
    openModal = modal;
    // Focus the close button for keyboard users
    setTimeout(function () {
      var c = modal.querySelector('.mfg-size-modal__close');
      if (c) c.focus();
    }, 30);

    // GA4 event — fires only when the modal actually opens (success state,
    // not just intent like the cta_click handler in analytics-events.liquid)
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'size_guide_open',
        page_type: document.body.classList.toString().match(/template-(\w+)/) ? RegExp.$1 : 'unknown',
        page_path: window.location.pathname,
        product_handle: window.location.pathname.split('/products/')[1] || null
      });
    } catch (e) { /* never break the modal on analytics */ }
  }

  // Delegate clicks
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.size-chart-link, a[data-cc-modal-contentelement*="size-chart"]');
    if (trigger) {
      var sel = trigger.getAttribute('data-cc-modal-contentelement');
      if (sel) {
        e.preventDefault();
        e.stopPropagation();
        open(sel);
        return;
      }
    }
    var closer = e.target.closest('[data-close]');
    if (closer && openModal && openModal.contains(closer)) {
      e.preventDefault();
      close();
    }
  }, true);

  // Escape closes + focus trap (Tab cycle inside modal)
  document.addEventListener('keydown', function (e) {
    if (!openModal) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var focusables = openModal.querySelectorAll(
      'button:not([disabled]), a[href], input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Tabs inside the chart (Pulgadas vs Centímetros) — delegate
  document.addEventListener('click', function (e) {
    if (!openModal) return;
    var tabBtn = e.target.closest('.size-chart__list button[role="tab"]');
    if (!tabBtn) return;
    e.preventDefault();
    var list = tabBtn.closest('.size-chart__list');
    var tabs = list ? list.querySelectorAll('button[role="tab"]') : [];
    tabs.forEach(function (t) {
      t.setAttribute('aria-selected', t === tabBtn ? 'true' : 'false');
      t.parentElement.classList.toggle('active', t === tabBtn);
    });
    var key = tabBtn.parentElement.getAttribute('data-links');
    var panels = openModal.querySelectorAll('.size-chart__content');
    panels.forEach(function (p) {
      var active = p.getAttribute('data-tabs') === key;
      p.classList.toggle('size-chart__content--active', active);
      p.style.display = active ? 'block' : 'none';
    });
  });
})();
